import { openDB } from 'idb';

const DB_NAME = 'liftads-db';
const VERSION = 3;

const dbp = openDB(DB_NAME, VERSION, {
  upgrade(db) {
    if (!db.objectStoreNames.contains('queue')) db.createObjectStore('queue', { keyPath: 'id' });
    if (!db.objectStoreNames.contains('context')) db.createObjectStore('context', { keyPath: 'userId' });
    if (!db.objectStoreNames.contains('pending')) db.createObjectStore('pending', { keyPath: 'key' });
    if (!db.objectStoreNames.contains('cache')) db.createObjectStore('cache', { keyPath: 'key' });
  },
});

export async function cacheSet(key, data) {
  const db = await dbp;
  await db.put('cache', { key, data });
}
export async function cacheGet(key) {
  const db = await dbp;
  const r = await db.get('cache', key);
  return r ? r.data : null;
}

export async function savePending(key, data) {
  const db = await dbp;
  await db.put('pending', { key, ...data });
}
export async function getAllPending() {
  const db = await dbp;
  return db.getAll('pending');
}
export async function deletePending(key) {
  const db = await dbp;
  await db.delete('pending', key);
}

export async function addToQueue(item) {
  const db = await dbp;
  await db.put('queue', item);
}
export async function updateQueueItem(id, patch) {
  const db = await dbp;
  const cur = await db.get('queue', id);
  if (!cur) return;
  await db.put('queue', { ...cur, ...patch });
}
export async function deleteQueueItem(id) {
  const db = await dbp;
  await db.delete('queue', id);
}
export async function getQueue() {
  const db = await dbp;
  const all = await db.getAll('queue');
  return all.sort((a, b) => (a.createdAt < b.createdAt ? -1 : 1));
}

export async function saveContext(userId, ctx) {
  const db = await dbp;
  await db.put('context', { userId, ...ctx });
}
export async function getContext(userId) {
  const db = await dbp;
  return (await db.get('context', userId)) || null;
}
